export enum LinkUploadPermissions {
  Upload = 'uploads',
}
